import { jsx as _jsx } from "react/jsx-runtime";
const BannerContent = ({ children }) => {
    return _jsx("div", { className: "flex items-start gap-2.5 sm:items-center", children: children });
};
export default BannerContent;
